import { createApp } from 'vue'

import App from './components/App.vue'
import './assets/styles/reset.css'
import './assets/styles/global.css'
import './registerServiceWorker'

createApp(App).mount('#app')
